import { graphql, useFragment } from 'react-relay';
import { getUserSessionCountryCode } from 'dibs-regional-info/exports/regionalInfoHelpers';

import { useEuEligible_viewer$key } from './__generated__/useEuEligible_viewer.graphql';

const viewerFragment = graphql`
    fragment useEuEligible_viewer on Viewer
    @argumentDefinitions(userCountryCode: { type: "String!" }) {
        isCountryInEu(country: $userCountryCode)
    }
`;

export const useEuEligible = ({
    viewer: viewerRef,
}: {
    viewer?: useEuEligible_viewer$key | null;
}): boolean => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const userCountryCode = getUserSessionCountryCode();

    return viewer?.isCountryInEu || userCountryCode === 'GB';
};
